import { createActions } from 'redux-actions';

export const {
  getAllMailHistory,
  getAllMailHistorySuccess,
  getAllMailHistoryError,
  mailSend,
  mailSendSuccess,
  mailSendError,
} = createActions(
  'GET_ALL_MAIL_HISTORY',
  'GET_ALL_MAIL_HISTORY_SUCCESS',
  'GET_ALL_MAIL_HISTORY_ERROR',
  'MAIL_SEND',
  'MAIL_SEND_SUCCESS',
  'MAIL_SEND_ERROR'
);
